import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface LedgerRow {
  key: React.ReactNode
  value: React.ReactNode
  tone?: 'default' | 'bad'
}

export interface EditorialLedgerProps extends Omit<BoxProps, 'children'> {
  rows: LedgerRow[]
}

const Root = styled(Box)({
  marginTop: 'var(--ds-space-6)',
  borderTop: '1px solid var(--ds-border)',
})

const Row = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  gap: 14,
  padding: '13px 0',
  borderBottom: '1px solid var(--ds-border)',
  alignItems: 'baseline',
})

const K = styled('span')({
  fontSize: 13.5,
  fontWeight: 620,
})

const V = styled('span', {
  shouldForwardProp: (p) => p !== 'tone',
})<{ tone?: 'default' | 'bad' }>(({ tone }) => ({
  fontFamily: 'var(--ds-font-mono)',
  fontSize: 10,
  letterSpacing: '0.08em',
  color: tone === 'bad' ? 'var(--ds-danger)' : 'var(--ds-ink-subtle)',
  textDecoration: tone === 'bad' ? 'line-through' : 'none',
  textDecorationThickness: tone === 'bad' ? '1px' : undefined,
}))

/** Label/value policy ledger — "Your 24.6MP original — KEPT" pattern from the Fidelity section. */
export function EditorialLedger({ rows, ...rest }: EditorialLedgerProps) {
  return (
    <Root {...rest}>
      {rows.map((row, i) => (
        <Row key={i}>
          <K>{row.key}</K>
          <V tone={row.tone}>{row.value}</V>
        </Row>
      ))}
    </Root>
  )
}
